var inherit = require("../general.js").inherit;
var mixin = require("../general.js").mixin;

var Root = require("./root.js");
var GlobalUid = require("./globalUid.js");
var LocalUid = require("./localUid.js");
var JsonParser = require("./jsonParser.js");
var Hashifier = require("./hashifier.js");

var HeavyHandler = require("./../../heavyHandler.js");

var NonShareableDataRoot = function () {
    Root.call(this);

    this.initGlobalUid();
    this.initLocalUid();
    this.initJsonParser();
};
inherit(NonShareableDataRoot, Root);
mixin(NonShareableDataRoot, GlobalUid, LocalUid, JsonParser, Hashifier);

module.exports = NonShareableDataRoot;
